import { Component } from '@angular/core';

@Component({
  selector: 'ajuda',
  templateUrl: 'ajuda.html'
})
export class AjudaPage {
	constructor() {}
}


// WEBPACK FOOTER //
// ./src/pages/ajuda/ajuda.ts